import React, { FC } from 'react';
import { Box } from '@mui/material';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

type EventFileItemProps = {
    url: string;
};
const EventFileItem: FC<EventFileItemProps> = ({ url }: EventFileItemProps) => {
    return (
        <a href={url} target="_blank" rel="noreferrer">
            <Box
                sx={{ bgcolor: '#f4f4f4', height: 90, borderRadius: 2, width: 150 }}
                display="flex"
                justifyContent="center"
                alignItems="center"
            >
                <InsertDriveFileIcon color="secondary" sx={{ fontSize: 50 }} />
            </Box>
        </a>
    );
};

export default EventFileItem;
